import React, { useCallback, useContext, useEffect } from 'react'
import { isBedbankOffer, isLEHotel, isTourV1Offer, isTourV2Offer } from 'lib/offer/offerTypes'
import BedbankCard from 'tripPlanner/components/Bookmark/BookmarkCard/BedbankCard'
import LEOfferCard from 'tripPlanner/components/Bookmark/BookmarkCard/LEOfferCard'
import TourBookmarkCard from 'tripPlanner/components/Bookmark/BookmarkCard/TourBookmarkCard'
import TourV2Card from 'tripPlanner/components/Bookmark/BookmarkCard/TourV2Card'

import { useInView } from 'react-intersection-observer'
import useOffer from 'hooks/Offers/useOffer'
import TopPicksForMeOfferSkeleton from './TopPicksForMeOfferSkeleton'
import styled from 'styled-components'
import OfferListEventsContext, { OfferListEvents } from 'components/OfferList/OfferListEventsContext'

const Tile = styled.div`
  height: 100%;

  > * {
    height: 100%;
  }
`

interface TrackedOfferProps {
  offerId: string;
  linkQuery?: URLSearchParams;
  preload: boolean;
  onClick?: () => void;
  position?: number;
}

function TopPicksForMeCarouselOffer(props: TrackedOfferProps) {
  const { offerId, linkQuery, preload, onClick, position } = props
  const [inViewRef, inView] = useInView({
    triggerOnce: true,
    rootMargin: '200px',
  })
  const [offer] = useOffer(offerId, { disabled: !preload && !inView })

  const dispatchOfferListEvent = useContext(OfferListEventsContext)

  useEffect(() => {
    if (inView && offer && position !== undefined) {
      dispatchOfferListEvent({
        type: OfferListEvents.productImpression,
        offer,
        position,
      })
    }
  }, [dispatchOfferListEvent, inView, offer, position])

  const onTileClick = useCallback(() => {
    if (offer) {
      onClick?.()

      if (position !== undefined) {
        dispatchOfferListEvent({
          type: OfferListEvents.productClick,
          offer,
          position,
        })
      }
    }
  }, [dispatchOfferListEvent, offer, onClick, position])

  return <Tile
    ref={inViewRef}
  >
    {!offer && <TopPicksForMeOfferSkeleton />}
    {offer && <>
      {isBedbankOffer(offer) && <BedbankCard
        offer={offer}
        onClick={onTileClick}
        linkQuery={linkQuery}
        aspectRatio="2:1"
        target="_blank"
      />}
      {isTourV2Offer(offer) && <TourV2Card
        offer={offer}
        onClick={onTileClick}
        linkQuery={linkQuery}
        aspectRatio="2:1"
        target="_blank"
      />}
      {isTourV1Offer(offer) && <TourBookmarkCard
        offer={offer}
        onClick={onTileClick}
        linkQuery={linkQuery}
        aspectRatio="2:1"
        target="_blank"
      />}
      {isLEHotel(offer) && <LEOfferCard
        offer={offer}
        onClick={onTileClick}
        linkQuery={linkQuery}
        aspectRatio="2:1"
        target="_blank"
      />}
    </>}
  </Tile>
}

export default TopPicksForMeCarouselOffer
